import { Modal } from 'react-bootstrap';
import styles from './CheckModal.module.css';

export default function CheckModal({ modalOpen, title, msg, afterYes, afterNo }) {
  const rootEl = typeof document !== 'undefined' ? document.getElementById('root') : null;

  return (
    <Modal
      show={modalOpen}
      centered
      backdrop="static"
      className={styles.modalRoot}
      dialogClassName={styles.dialog}
      contentClassName={styles.modalContent}
      container={rootEl}
      onHide={afterNo}
    >
      <Modal.Header className={styles.modalHeader}>
        <Modal.Title className={styles.modalTitle}>
          <i className="bi bi-shield-exclamation" aria-hidden="true"></i>
          {title}
        </Modal.Title>
      </Modal.Header>
      
      <Modal.Body className={styles.modalBody}>
        {msg}
      </Modal.Body>
      
      <Modal.Footer>
        <button
          type="button"
          className={styles.btnCancel}
          onClick={afterNo}
        >
          取消
        </button>
        <button
          type="button"
          className={styles.btnConfirm}
          onClick={afterYes}
        >
          <i className="bi bi-check2 me-1"></i>
          確認執行
        </button>
      </Modal.Footer>
    </Modal>
  );
}